import type { FC } from 'react';
import { Button } from 'src/components/buttons-and-actions/button';
import { BugIcon } from 'src/components/media-and-icons/icons/bug';
import { Tooltip } from 'src/components/overlay/tooltip';
import { toggleNewDesign } from 'src/pages/new-design/is-new-design';

export const NewDesignToggleDev: FC = () => {
  return (
    <Tooltip
      content="Only available on ENT and during local development."
      noTabIndex
    >
      {(targetProps) => (
        <Button onClick={toggleNewDesign} {...targetProps}>
          <BugIcon size="sm" className="inline" /> Quick Toggle
        </Button>
      )}
    </Tooltip>
  );
};
